<template>
  <div class="iv-expand-info">
    <div class="iv-pos-r">
      <span @click="expandInfo" class="iv-pointer" v-if="!showText">
        <slot name="title"></slot>
      </span>
      <slot name="title" v-else></slot>
      <span class="iv-fs-16 iv-fc-45 iv-pointer" :class="{'iv-expand-info-expand': showText}" @click="expandInfo">
        <span v-if="showText">{{expandText}}</span>
        <IconFont :type="`${expand ? 'up' : 'down'}`" class="iv-m-l-8"></IconFont>
      </span>
    </div>
    <div v-show="expand">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import IconFont from '@/components/iconfont'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: true
    },
    defaultExpand: { //默认展开
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expand: false,
      expandText: '收起'
    }
  },
  created () {
    if (this.defaultExpand) {
      this.expandInfo()
    }
  },
  methods: {
    //展开收起
    expandInfo () {
      this.expand = !this.expand
      this.expandText = this.expand === true ? '收起' : '展开'
    }
  },
  components: {
    IconFont
  }
}
</script>

<style lang="scss" scoped>
.iv-expand-info-expand {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);    
}
</style>
